module.exports = __webpack_public_path__ + "51a8985152c61716e5f81896916f3dca.png";